import ReactGA from "react-ga";

// 複数トラッキングIDを送信するときのAPIにあわせたデータを出力
export const multipleGaTrackingUtil = (trackingIds: string[]) => {
  const trackingIdArray = new Array();
  const trackingNameArray = new Array();
  for (let i = 0; i < trackingIds.length; i++) {
    if (i === 0) {
      trackingIdArray.push({
        trackingId: trackingIds[i]
      });
    } else {
      // gaOptions.name にハイフンは使えないので
      const name = trackingIds[i].replace(/-/g, "");
      trackingIdArray.push({
        trackingId: trackingIds[i],
        gaOptions: {
          name: name
        }
      });
      trackingNameArray.push(name);
    }
  }
  return [trackingIdArray, trackingNameArray];
};

export const pvListener = (
  slug: any,
  num: any,
  currentPage: any,
  trackingIds: string[]
) => {
  const [trackingIdArray, trackingNameArray] = multipleGaTrackingUtil(
    trackingIds
  );
  // 複数トラッキングIDを送信するときは引数の数が違うことに配慮
  if (slug && num && currentPage) {
    if (trackingNameArray && trackingNameArray.length > 0) {
      ReactGA.pageview(
        `/viewer/${slug}/${num}?page=${currentPage}`,
        trackingNameArray
      );
    } else {
      ReactGA.pageview(`/viewer/${slug}/${num}?page=${currentPage}`);
    }
  }
};
